import Brightness3Icon from "@mui/icons-material/Brightness3";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import BrightnessAutoIcon from "@mui/icons-material/BrightnessAuto";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  Grid,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import FlagAR from "../../assets/images/flags/4x3/ar.svg";
import FlagBG from "../../assets/images/flags/4x3/bg.svg";
import FlagPB from "../../assets/images/flags/4x3/br.svg";
import FlagZH from "../../assets/images/flags/4x3/cn.svg";
import FlagCS from "../../assets/images/flags/4x3/cz.svg";
import FlagDE from "../../assets/images/flags/4x3/de.svg";
import FlagDA from "../../assets/images/flags/4x3/dk.svg";
import FlagET from "../../assets/images/flags/4x3/ee.svg";
import FlagES from "../../assets/images/flags/4x3/es.svg";
import FlagFI from "../../assets/images/flags/4x3/fi.svg";
import FlagFR from "../../assets/images/flags/4x3/fr.svg";
import FlagEB from "../../assets/images/flags/4x3/gb.svg";
import FlagEL from "../../assets/images/flags/4x3/gr.svg";
import FlagHU from "../../assets/images/flags/4x3/hu.svg";
import FlagID from "../../assets/images/flags/4x3/id.svg";
import FlagIT from "../../assets/images/flags/4x3/it.svg";
import FlagJA from "../../assets/images/flags/4x3/jp.svg";
import FlagKR from "../../assets/images/flags/4x3/kr.svg";
import FlagLT from "../../assets/images/flags/4x3/lt.svg";
import FlagLV from "../../assets/images/flags/4x3/lv.svg";
import FlagNL from "../../assets/images/flags/4x3/nl.svg";
import FlagNO from "../../assets/images/flags/4x3/no.svg";
import FlagPL from "../../assets/images/flags/4x3/pl.svg";
import FlagPP from "../../assets/images/flags/4x3/pt.svg";
import FlagRO from "../../assets/images/flags/4x3/ro.svg";
import FlagRU from "../../assets/images/flags/4x3/ru.svg";
import FlagSV from "../../assets/images/flags/4x3/se.svg";
import FlagSL from "../../assets/images/flags/4x3/si.svg";
import FlagSK from "../../assets/images/flags/4x3/sk.svg";
import FlagTR from "../../assets/images/flags/4x3/tr.svg";
import FlagUA from "../../assets/images/flags/4x3/ua.svg";
import FlagEU from "../../assets/images/flags/4x3/us.svg";
import { DEBUG_FLAG } from "../../constants/debug";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useAuth } from "../../context/auth-context";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { validateBoolean } from "../../functions/validateBoolean";
import { useLocalStorage, useSessionStorage } from "../../utils/hooks";
import { FullPageSpinner } from "../lib";
import Layout from "../shared/components/LayoutComponent";
import MessageBox from "../shared/components/MessageBox";
import Page from "../shared/components/PageComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import NotificationSettings from "./NotificationSettings";
const styles = (theme) => ({
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
  },
});
const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: 0,
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.background.default,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.background.default,
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});
function Settings({ updateTitle, classes, client }) {
  const { t, i18n } = useTranslation();
  const [saveUsername, setSaveUsername] = useLocalStorage(LOCAL_STORAGE_KEY.saveUsername);
  const [username] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [priv, setPriv] = useLocalStorage(LOCAL_STORAGE_KEY.private);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();
  const { hideMessage, showErrorMessage } = useMessage();
  const [useDeviceAuth, setUseDeviceAuth] = useLocalStorage(LOCAL_STORAGE_KEY.useDeviceAuth);
  const [, setRefreshToken] = useLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [deviceId] = useLocalStorage(DEBUG_FLAG() ? LOCAL_STORAGE_KEY.deviceIdLocal : LOCAL_STORAGE_KEY.deviceId);
  const [theme, setTheme] = useLocalStorage(LOCAL_STORAGE_KEY.theme);
  const [language, setLanguage] = useLocalStorage(LOCAL_STORAGE_KEY.language);
  const [openThemeDialog, setOpenThemeDialog] = useState(false);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [languageFilter, setLanguageFilter] = useState("");
  const [openLanguageDialog, setOpenLanguageDialog] = useState(false);
  const [openNotificationDialog, setOpenNotificationDialog] = useState(false);
  const [allgNotiSettings, setAllgNotiSettings] = useState([]);
  // const [test, setTest] = useState([2,5])f
  const { user } = useAuth();

  const languages = [
    {
      text: "Arabic",
      value: "AR",
      icon: FlagAR,
    },
    {
      text: "Bulgarian",
      value: "BG",
      icon: FlagBG,
    },
    {
      text: "Czech",
      value: "CS",
      icon: FlagCS,
    },
    {
      text: "Danish",
      value: "DA",
      icon: FlagDA,
    },
    {
      text: "German",
      value: "DE",
      icon: FlagDE,
    },
    {
      text: "Greek",
      value: "EL",
      icon: FlagEL,
    },
    {
      text: "English (British)",
      value: "EB",
      icon: FlagEB,
    },
    {
      text: "English (American)",
      value: "EU",
      icon: FlagEU,
    },
    {
      text: "Spanish",
      value: "ES",
      icon: FlagES,
    },
    {
      text: "Estonian",
      value: "ET",
      icon: FlagET,
    },
    {
      text: "Finnish",
      value: "FI",
      icon: FlagFI,
    },
    {
      text: "French",
      value: "FR",
      icon: FlagFR,
    },
    {
      text: "Hungarian",
      value: "HU",
      icon: FlagHU,
    },
    {
      text: "Italian",
      value: "IT",
      icon: FlagIT,
    },
    {
      text: "Japanese",
      value: "JA",
      icon: FlagJA,
    },
    {
      text: "Lithuanian",
      value: "LT",
      icon: FlagLT,
    },
    {
      text: "Latvian",
      value: "LV",
      icon: FlagLV,
    },
    {
      text: "Dutch",
      value: "NL",
      icon: FlagNL,
    },
    {
      text: "Polish",
      value: "PL",
      icon: FlagPL,
    },
    {
      text: "Portuguese (all Portuguese varieties excluding Brazilian Portuguese)",
      value: "PP",
      icon: FlagPP,
    },
    {
      text: "Portuguese (Brazilian)",
      value: "PB",
      icon: FlagPB,
    },
    {
      text: "Romanian",
      value: "RO",
      icon: FlagRO,
    },
    {
      text: "Russian",
      value: "RU",
      icon: FlagRU,
    },
    {
      text: "Slovak",
      value: "SK",
      icon: FlagSK,
    },
    {
      text: "Slovenian",
      value: "SL",
      icon: FlagSL,
    },
    {
      text: "Swedish",
      value: "SV",
      icon: FlagSV,
    },
    {
      text: "Chinese",
      value: "ZH",
      icon: FlagZH,
    },
    {
      text: "Indonesian",
      value: "ID",
      icon: FlagID,
    },
    {
      text: "Korean",
      value: "KO",
      icon: FlagKR,
    },
    {
      text: "Norwegian",
      value: "NB",
      icon: FlagNO,
    },
    {
      text: "Turkish",
      value: "TR",
      icon: FlagTR,
    },
    {
      text: "Ukrainian",
      value: "UK",
      icon: FlagUA,
    },
  ];
  const themes = [
    {
      text: t("Hell"),
      value: "light",
      icon: <Brightness7Icon />,
    },
    {
      text: t("Dunkel"),
      value: "dark",
      icon: <Brightness3Icon />,
    },
    {
      text: t("System"),
      value: "system",
      icon: <BrightnessAutoIcon />,
    },
  ];
  useEffect(() => {
    updateTitle(t("Einstellungen"));
    if (theme === "") setTheme("system");
    // eslint-disable-next-line
  }, []);
  const privateCb = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
      setPriv(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
        if (response.data.message === "Admincode bestaetigen") {
          navigate("login-admincode");
        }
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const languageCb = (response) => {
    if (response.status === 200) {
      window.location.reload();
    } else {
      setIsSending(false);
      showErrorMessage(response.data.message);
    }
  };
  const deviceAuthIOSCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setUseDeviceAuth(response.data.status);
      setRefreshToken(response.data.refreshToken);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const deviceAuthDeleteCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setUseDeviceAuth("false");
      setRefreshToken("");
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const deviceAuthAndroidCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setRefreshToken(response.data.refreshToken);
      var encryptConfig = {
        clientId: "ectool",
        username: username.replace("/", ""),
        password: response.data.refreshToken,
        maxAttempts: 5,
        locale: "de",
        dialogTitle: "Authorisierung",
        dialogMessage: "Bitte legen Sie Ihren Finger auf",
      }; // See config object for required parameters
      // Set config and success callback
      window.FingerprintAuth.encrypt(
        encryptConfig,
        function (_fingerResult) {
          console.log("successCallback(): " + JSON.stringify(_fingerResult));
          setUseDeviceAuth("true");
          localStorage.setItem(LOCAL_STORAGE_KEY.androidToken, _fingerResult.token);
          if (_fingerResult.withFingerprint) {
            console.log("Successfully encrypted credentials.");
          } else if (_fingerResult.withBackup) {
            console.log("Authenticated with backup password");
          }
          // Error callback
        },
        function (err) {
          setRefreshToken("");
          if (err === "Cancelled") {
            console.log("FingerprintAuth Dialog Cancelled!");
          } else {
            console.log("FingerprintAuth Error: " + err);
            setUseDeviceAuth("false");
          }
        },
      );
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const handleThemeChange = (themeObj) => {
    setTheme(themeObj.value);
  };
  const handleCloseThemeDialog = () => {
    setOpenThemeDialog(false);
  };
  const handleLanguageChange = (languageObj) => {
    setLanguage(languageObj.value);
    // if (languageObj.value === "AR") {
    //   document.documentElement.setAttribute('dir', 'rtl');
    // } else {
    //   document.documentElement.setAttribute('dir', 'ltr');
    // }
    i18n.changeLanguage(languageObj.value);
    setIsSending(true);
    const payload = {
      language: languageObj.value,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "language/change", payload, headers, languageCb, errorCb);
  };

  const errorCb = () => {
    setIsSending(false);
    showErrorMessage(t("Sprache konnte nicht gesetzt werden."));
  };

  const loadNotifiCations = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("GET", "notif-settings", null, headers, lodNotificationCB);
  };
  const lodNotificationCB = (response) => {
    setAllgNotiSettings(response.data.list);
    setOpenNotificationDialog(true);
  };

  const handleCloseLanguageDialog = () => {
    setOpenLanguageDialog(false);
  };

  const messageBoxResult = (result) => {
    if (result === "YES") {
      //setMessageBoxOpen()
      setIsLoading(true);
      const payload = {
        deviceId: deviceId,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "delete/admincode", payload, headers, privateCb);
    }
    setMessageBoxOpen(false);
  };

  const handleLanguageFilterChange = ({ target: { value } }) => {
    setLanguageFilter(value);
  };

  const changeWochenTag = (tag, status) => {
    var neuerStatus = status === true ? "1" : "0";
    var zwis = allgNotiSettings.tage;
    zwis = zwis.split("-");
    zwis[tag] = neuerStatus;
    zwis = zwis.join("-");
    var zwis2 = allgNotiSettings;
    zwis2.tage = zwis;
    setAllgNotiSettings({ ...zwis2 });
  };

  const saveNotifications = () => {
    const indexedSettings = allgNotiSettings.reduce((acc, item) => {
      acc[item.key] = item.wert;
      return acc;
    }, {});

    const payload = {
      settings: indexedSettings,
    };

    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    apiRequest("POST", "save-notif-settings", payload, headers, saveCB);
  };

  const saveCB = (response) => {
    if (response.status === 200) {
      setOpenNotificationDialog(false);
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    switch (name) {
      case "private":
        if (checked === false) {
          setMessageBoxOpen(true);
        } else {
          navigate("/verify-admincode", { from: "/settings" });
        }
        break;
      case "saveUsername":
        setSaveUsername(checked ? "true" : "false");
        if (!checked) {
          setUseDeviceAuth("false");
          setRefreshToken("");
        }
        break;
      case "darkDesign":
        setTheme(checked ? "dark" : "light");
        break;
      case "useDeviceAuth":
        if (checked) {
          const payload = {
            deviceId: deviceId,
            status: checked,
          };
          const headers = {
            Authorization: "Bearer " + accessToken,
          };
          switch (window.cordova.platformId) {
            case "android":
              try {
                window.FingerprintAuth.isAvailable(function (result) {
                  setIsLoading(true);
                  console.log("FingerprintAuth available: " + JSON.stringify(result));
                  // If has fingerprint device and has fingerprints registered
                  if (result.isAvailable === false) {
                    showErrorMessage(t("Die Geräteaktivierung kann für dieses Gerät nicht aktiviert werden."));
                  } else if (result.hasEnrolledFingerprints === false) {
                    showErrorMessage(t("Sie haben keine Fingerabdrücke in diesem Gerät eingespeichert."));
                  }
                  if (result.isAvailable === true && result.hasEnrolledFingerprints === true) {
                    apiRequest("POST", "deviceauth", payload, headers, deviceAuthAndroidCb);
                  } else {
                    setIsLoading(false);
                  }
                });
              } catch (error) {}
              break;
            case "ios":
              window.CID.checkAuth(
                "Prüfe Geräteauthentifizierung",
                function (res) {
                  if (res === "success") {
                    setIsLoading(true);
                    apiRequest("POST", "deviceauth", payload, headers, deviceAuthIOSCb);
                    //  setUseDeviceAuth('true');
                  } else {
                    showErrorMessage(t("Geräteauthentifizierung fehlgeschlagen"));
                  }
                },
                function (err) {
                  console.log(err);
                  showErrorMessage(t("Geräteauthentifizierung fehlgeschlagen"));
                },
              );
              break;
            default:
              showErrorMessage(t("Biometrie nicht vorhanden"));
              setUseDeviceAuth("false");
              break;
          }
        } else {
          setIsLoading(true);
          const payload = {
            deviceId: deviceId,
            status: checked,
          };
          const headers = {
            Authorization: "Bearer " + accessToken,
          };
          switch (window.cordova.platformId) {
            case "android":
              window.FingerprintAuth.delete(
                {
                  clientId: "ectool",
                  username: username.replace("/", ""),
                },
                (result) => {},
                (err) => {
                  console.log(err);
                  showErrorMessage(t("Fingerabdruck konnte nicht entfernt werden"));
                },
              );
              apiRequest("POST", "deviceauth", payload, headers, deviceAuthDeleteCb);
              break;
            case "ios":
              apiRequest("POST", "deviceauth", payload, headers, deviceAuthDeleteCb);
              break;
            default:
              setUseDeviceAuth("false");
              setRefreshToken("");
              break;
          }
        }
        break;
      default:
        console.log(name, checked);
        break;
    }
  };
  return (
    <Page>
      <Layout>
        <TableContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>{t("Username speichern")}</TableCell>
                <TableCell align="right">
                  <IOSSwitch checked={saveUsername !== "false" ? true : false} onChange={handleSwitchChange} name="saveUsername" />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{t("Privaten Bereich aktivieren")}</TableCell>
                <TableCell align="right">
                  <IOSSwitch disabled={isLoading} checked={validateBoolean(priv)} onChange={handleSwitchChange} name="private" />
                </TableCell>
              </TableRow>
              {window.cordova && (
                <TableRow>
                  <TableCell>{window.cordova.platformId === "android" ? t("Login mit Fingerabdruck") : t("Biometrie für Login")}</TableCell>
                  <TableCell align="right">
                    <IOSSwitch disabled={isLoading} checked={validateBoolean(useDeviceAuth)} onChange={handleSwitchChange} name="useDeviceAuth" />
                  </TableCell>
                </TableRow>
              )}
              <TableRow onClick={() => setOpenThemeDialog(true)}>
                <TableCell>{t("Design")}</TableCell>
                <TableCell align="right">
                  <Typography variant="body2">
                    {
                      themes.find((obj) => {
                        console.log(obj.value, theme);
                        return obj.value === theme;
                      }).text
                    }
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow onClick={() => setOpenLanguageDialog(true)}>
                <TableCell>{t("Sprache")}</TableCell>
                <TableCell align="right" padding="none">
                  <Box p={2} py={1}>
                    <img
                      height={30}
                      alt={languages.find((obj) => obj.value === language.toUpperCase())?.text}
                      src={languages.find((obj) => obj.value === language.toUpperCase())?.icon}
                    />
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow onClick={() => loadNotifiCations()}>
                <TableCell>{t("Benachrichtigungen")}</TableCell>
                <TableCell align="right" padding="none">
                  <Box p={2} py={1}>
                    <NotificationsActiveIcon color="primary" />
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog onClose={handleCloseThemeDialog} fullWidth aria-labelledby="theme-dialog-title" open={openThemeDialog}>
          <DialogTitle id="theme-dialog-title">{t("Design")}</DialogTitle>
          <List>
            {themes.map((themeObject) => (
              <ListItemButton onClick={() => handleThemeChange(themeObject)} key={themeObject.value}>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>{themeObject.icon}</Avatar>
                </ListItemAvatar>
                <ListItemText primary={themeObject.text} />
              </ListItemButton>
            ))}
          </List>
        </Dialog>
        <ResponsiveDialog title={t("Sprache ändern")} setOpen={handleCloseLanguageDialog} aria-labelledby="language-dialog-title" open={openLanguageDialog}>
          <Grid container alignContent={"center"} justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <Box p={2}>
                <TextField value={languageFilter} onChange={handleLanguageFilterChange} placeholder={t("Suche")} size="small" variant="outlined" fullWidth />
              </Box>
              <List>
                {languages
                  .filter((element) => element.text.toLowerCase().includes(languageFilter.toLowerCase()))
                  .sort()
                  .map((themeObject) => (
                    <ListItemButton onClick={() => handleLanguageChange(themeObject)} key={themeObject.value}>
                      <ListItemIcon>
                        <div style={{ height: "24px", width: "32px" }}>
                          <img src={themeObject.icon} />
                        </div>
                      </ListItemIcon>
                      <ListItemText primary={t(themeObject.text)} />
                    </ListItemButton>
                  ))}
              </List>
            </Grid>
          </Grid>
        </ResponsiveDialog>
        <ResponsiveDialog
          title={"Benachrichtigungen"}
          open={openNotificationDialog}
          setOpen={(o) => setOpenNotificationDialog(o)}
          actionButton={
            allgNotiSettings != undefined &&
            allgNotiSettings?.length != 0 && (
              <>
                <Button onClick={() => saveNotifications()}>{t("Speichern")}</Button>
              </>
            )
          }
        >
          <Box p={2}>
            <NotificationSettings allgNotiSettings={allgNotiSettings} setAllgNotiSettings={setAllgNotiSettings} />
          </Box>
        </ResponsiveDialog>
      </Layout>
      {isSending && <FullPageSpinner />}
      <MessageBox
        title={t("Hinweis")}
        text={t("Wollen Sie den privaten Bereich wirklich deaktivieren?")}
        buttons="YESNO"
        onClose={() => setMessageBoxOpen(false)}
        open={messageBoxOpen}
        handleResponse={(r) => messageBoxResult(r)}
      />
    </Page>
  );
}
export default withStyles(styles)(Settings);
